import ProvidersColors from './RoutePathProvidersColors';

const DRAW_MODE_COLORS = {
  ACTIVE: '#b42e6f'
};

const STYLE_PARAMETERS = {
  MIDPOINT: {
    COLOR:  ProvidersColors.custom,
    RADIUS: 6
  },
  LINE_INACTIVE: {
    COLOR: ProvidersColors.custom,
    OPACITY: 0.7,
    WIDTH: 4
  },
  LINE_ACTIVE: {
    COLOR: ProvidersColors.custom,
    OPACITY: 0.6,
    DASH_ARRAY: [0.2, 2],
    WIDTH: 4,
  },
  VERTEX_INACTIVE: {
    COLOR: '#fff',
    OPACITY: 1,
    RADIUS: 5,

    STROKE: {
      COLOR: ProvidersColors.custom,
      OPACITY: 1,
      RADIUS: 7
    }
  },
  POINT_INACTIVE: {
    COLOR: '#fff',
    OPACITY: 1,
    RADIUS: 6,

    STROKE: {
      COLOR: ProvidersColors.custom,
      OPACITY: 1,
      RADIUS: 8
    }
  },
  POINT_ACTIVE: {
    COLOR: '#fff',
    RADIUS: 6,

    STROKE: {
      COLOR: DRAW_MODE_COLORS.ACTIVE,
      RADIUS: 8
    }
  }
};

const DRAW_MODE_STYLES = [
  {
    'id': 'gl-draw-polygon-fill-inactive',
    'type': 'fill',
    'filter': ['all',
      ['==', 'active', 'false'],
      ['==', '$type', 'Polygon'],
      ['!=', 'mode', 'static']
    ],
    'paint': {
      'fill-color': '#3bb2d0',
      'fill-outline-color': '#3bb2d0',
      'fill-opacity': 0.1
    }
  },
  {
    'id': 'gl-draw-polygon-fill-active',
    'type': 'fill',
    'filter': ['all', ['==', 'active', 'true'], ['==', '$type', 'Polygon']],
    'paint': {
      'fill-color': '#fbb03b',
      'fill-outline-color': '#fbb03b',
      'fill-opacity': 0.1
    }
  },
  {
    'id': 'gl-draw-polygon-midpoint',
    'type': 'circle',
    'filter': ['all',
      ['==', '$type', 'Point'],
      ['==', 'meta', 'midpoint']],
    'paint': {
      'circle-radius': STYLE_PARAMETERS.MIDPOINT.RADIUS,
      'circle-color':  STYLE_PARAMETERS.MIDPOINT.COLOR,
    }
  },
  {
    'id': 'gl-draw-polygon-stroke-inactive',
    'type': 'line',
    'filter': ['all',
      ['==', 'active', 'false'],
      ['==', '$type', 'Polygon'],
      ['!=', 'mode', 'static']
    ],
    'layout': {
      'line-cap': 'round',
      'line-join': 'round'
    },
    'paint': {
      'line-color': '#3bb2d0',
      'line-width': 2
    }
  },
  {
    'id': 'gl-draw-polygon-stroke-active',
    'type': 'line',
    'filter': ['all', ['==', 'active', 'true'], ['==', '$type', 'Polygon']],
    'layout': {
      'line-cap': 'round',
      'line-join': 'round'
    },
    'paint': {
      'line-color': '#fbb03b',
      'line-dasharray': [0.2, 2],
      'line-width': 2
    }
  },
  {
    'id': 'gl-draw-line-inactive',
    'type': 'line',
    'filter': ['all',
      ['==', 'active', 'false'],
      ['==', '$type', 'LineString'],
      ['!=', 'mode', 'static']
    ],
    'layout': {
      'line-cap': 'round',
      'line-join': 'round'
    },
    'paint': {
      'line-color':   STYLE_PARAMETERS.LINE_INACTIVE.COLOR,
      'line-opacity': STYLE_PARAMETERS.LINE_INACTIVE.OPACITY,
      'line-width':   STYLE_PARAMETERS.LINE_INACTIVE.WIDTH
    }
  },
  {
    'id': 'gl-draw-line-active',
    'type': 'line',
    'filter': ['all',
      ['==', '$type', 'LineString'],
      ['==', 'active', 'true']
    ],
    'layout': {
      'line-cap': 'round',
      'line-join': 'round'
    },
    'paint': {
      'line-color':     STYLE_PARAMETERS.LINE_ACTIVE.COLOR,
      'line-opacity':   STYLE_PARAMETERS.LINE_ACTIVE.OPACITY,
      // 'line-dasharray': STYLE_PARAMETERS.LINE_ACTIVE.DASH_ARRAY,
      'line-width':     STYLE_PARAMETERS.LINE_ACTIVE.WIDTH
    }
  },
  {
    'id': 'gl-draw-polygon-and-line-vertex-stroke-inactive',
    'type': 'circle',
    'filter': ['all',
      ['==', 'meta', 'vertex'],
      ['==', '$type', 'Point'],
      ['!=', 'mode', 'static']
    ],
    'paint': {
      'circle-radius':  STYLE_PARAMETERS.VERTEX_INACTIVE.STROKE.RADIUS,
      'circle-color':   STYLE_PARAMETERS.VERTEX_INACTIVE.STROKE.COLOR,
      'circle-opacity': STYLE_PARAMETERS.VERTEX_INACTIVE.STROKE.OPACITY
    }
  },
  {
    'id': 'gl-draw-polygon-and-line-vertex-inactive',
    'type': 'circle',
    'filter': ['all',
      ['==', 'meta', 'vertex'],
      ['==', '$type', 'Point'],
      ['!=', 'mode', 'static']
    ],
    'paint': {
      'circle-radius': STYLE_PARAMETERS.VERTEX_INACTIVE.RADIUS,
      'circle-color':  STYLE_PARAMETERS.VERTEX_INACTIVE.COLOR,
      'circle-opacity': STYLE_PARAMETERS.VERTEX_INACTIVE.OPACITY
    }
  },
  {
    'id': 'gl-draw-point-point-stroke-inactive',
    'type': 'circle',
    'filter': ['all',
      ['==', 'active', 'false'],
      ['==', '$type', 'Point'],
      ['==', 'meta', 'feature'],
      ['!=', 'mode', 'static']
    ],
    'paint': {
      'circle-radius':  STYLE_PARAMETERS.POINT_INACTIVE.STROKE.RADIUS,
      'circle-opacity': STYLE_PARAMETERS.POINT_INACTIVE.STROKE.OPACITY,
      'circle-color':   STYLE_PARAMETERS.POINT_INACTIVE.STROKE.COLOR
    }
  },
  {
    'id': 'gl-draw-point-inactive',
    'type': 'circle',
    'filter': ['all',
      ['==', 'active', 'false'],
      ['==', '$type', 'Point'],
      ['==', 'meta', 'feature'],
      ['!=', 'mode', 'static']
    ],
    'paint': {
      'circle-radius': 5,
      'circle-color': '#3bb2d0'
    }
  },
  {
    'id': 'gl-draw-point-stroke-active',
    'type': 'circle',
    'filter': ['all',
      ['==', '$type', 'Point'],
      ['==', 'active', 'true'],
      ['!=', 'meta', 'midpoint']
    ],
    'paint': {
      'circle-radius': STYLE_PARAMETERS.POINT_ACTIVE.STROKE.RADIUS,
      'circle-color':  STYLE_PARAMETERS.POINT_ACTIVE.STROKE.COLOR
    }
  },
  {
    'id': 'gl-draw-point-active',
    'type': 'circle',
    'filter': ['all',
      ['==', '$type', 'Point'],
      ['!=', 'meta', 'midpoint'],
      ['==', 'active', 'true']],
    'paint': {
      'circle-radius': STYLE_PARAMETERS.POINT_ACTIVE.RADIUS,
      'circle-color':  STYLE_PARAMETERS.POINT_ACTIVE.COLOR
    }
  },
  {
    'id': 'gl-draw-polygon-fill-static',
    'type': 'fill',
    'filter': ['all', ['==', 'mode', 'static'], ['==', '$type', 'Polygon']],
    'paint': {
      'fill-color': '#404040',
      'fill-outline-color': '#404040',
      'fill-opacity': 0.1
    }
  },
  {
    'id': 'gl-draw-polygon-stroke-static',
    'type': 'line',
    'filter': ['all', ['==', 'mode', 'static'], ['==', '$type', 'Polygon']],
    'layout': {
      'line-cap': 'round',
      'line-join': 'round'
    },
    'paint': {
      'line-color': '#404040',
      'line-width': 2
    }
  },
  {
    'id': 'gl-draw-line-static',
    'type': 'line',
    'filter': ['all', ['==', 'mode', 'static'], ['==', '$type', 'LineString']],
    'layout': {
      'line-cap': 'round',
      'line-join': 'round'
    },
    'paint': {
      'line-color': '#404040',
      'line-width': 4
    }
  },
  {
    'id': 'gl-draw-point-static',
    'type': 'circle',
    'filter': ['all', ['==', 'mode', 'static'], ['==', '$type', 'Point']],
    'paint': {
      'circle-radius': 5,
      'circle-color': '#404040'
    }
  }
];

export default DRAW_MODE_STYLES;